// img
import fbI from "../../assets/images/layout/footer/fbI.png";
import ytbI from "../../assets/images/layout/footer/youtubeI.png";
import annouceI from "../../assets/images/layout/footer/annouceI.PNG";
import bhxI from "../../assets/images/layout/footer/bhxI.PNG";
import dmxI from "../../assets/images/layout/footer/dmxI.PNG";
import farmI from "../../assets/images/layout/footer/farmI.PNG";
import hireI from "../../assets/images/layout/footer/hireI.PNG";
import kidI from "../../assets/images/layout/footer/kidI.PNG";
import medicI from "../../assets/images/layout/footer/medicI.PNG";
import ncsI from "../../assets/images/layout/footer/ncsI.PNG";
import protectI from "../../assets/images/layout/footer/protectI.PNG";
import reportI from "../../assets/images/layout/footer/reportI.PNG";
import sportI from "../../assets/images/layout/footer/sportI.PNG";
import topzoneI from "../../assets/images/layout/footer/topzoneI.PNG";
import ttI from "../../assets/images/layout/footer/ttI.PNG";

// 15 icon
export const arrI = [{
        icon: "fb social",
        content: "3745.5k Fan ",
        link: "https://www.avasport.com/",
        path: fbI,
    },
    {
        icon: "ytb social",
        content: "846k Đăng ký ",
        link: "https://www.avasport.com/",

        path: ytbI,
    },
    {
        icon: "annouce certificate",
        content: "",
        link: "https://www.avasport.com/",
        path: annouceI,
    },
    {
        icon: "protect certificate",
        content: "",
        link: "https://www.avasport.com/",
        path: protectI,
    },
    {
        icon: "report certificate",
        content: "",
        link: "https://www.avasport.com/",
        path: reportI,
    },
    {
        icon: "ncsI certificate",
        content: "",
        link: "https://www.avasport.com/",
        path: ncsI,
    },
];
export const brandArr = [{
        icon: "sport",
        content: "avasport",
        link: "https://www.avasport.com/",
        path: sportI,
    },
    {
        icon: "topzone",
        content: "",
        link: "https://www.avasport.com/",
        path: topzoneI,
    },
    {
        icon: "tt",
        content: "",
        link: "https://www.avasport.com/",
        path: ttI,
    },
    {
        icon: "farm",
        content: "",
        link: "https://www.avasport.com/",
        path: farmI,
    },
    {
        icon: "hire",
        content: "",
        link: "https://www.avasport.com/",
        path: hireI,
    },
    {
        icon: "kidI",
        content: "",
        link: "https://www.avasport.com/",
        path: kidI,
    },
    {
        icon: "medic",
        content: "",
        link: "https://www.avasport.com/",
        path: medicI,
    },
    {
        icon: "bhx",
        content: "",
        link: "https://www.avasport.com/",
        path: bhxI,
    },

    {
        icon: "dmx",
        content: "",
        path: dmxI,
        link: "https://www.avasport.com/",

    },
];